export default __webpack_public_path__ + "static/img/vogue_scene_animated_0764.20fb57f.jpg";